import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'custom-text-editor-dialog',
    standalone: true,
    imports: [TranslateModule, MatDialogModule, MatButtonModule],
    templateUrl: './custom-text-editor-dialog.component.html',
    styleUrl: './custom-text-editor-dialog.component.scss'
})
export class CustomTextEditorDialogComponent {
    data = inject(MAT_DIALOG_DATA);
}
